import React from 'react';
import MetaTags from '../meta/MetaTags.jsx';
import './about.css';

export default function About() {
  return (
    <>
      <MetaTags profileKey="about" />
      <main className="about-page">
        <div className="about-bg" aria-hidden="true">
          <div className="mountain mountain--far" />
          <div className="mountain mountain--near" />
          <div className="leaves">
            {/* Subtle maple leaves - low opacity, slow float */}
            {Array.from({ length: 7 }).map((_, i) => (
              <span key={i} className={`leaf leaf--${i+1}`} aria-hidden="true" />
            ))}
          </div>
        </div>

        <section className="section-hero">
          <div className="section-hero__inner">
            <h1 className="section-hero__title">✨ Our Story</h1>
            <p className="section-hero__subtitle">We Gather, Therefore We Build</p>
          </div>
        </section>

        {/* Blog-style free-flow prose */}
        <section className="section-prose">
          <div className="block-story">
            <p>
              Getting together is one of the most human things we do, whether around a dinner table or on a trip,
              or at a late-night hangout. But somewhere along the way, planning those moments got harder:
              too many chats, too many tools, and not enough time to simply enjoy.
            </p>
            <p>
              PartyDecider was created to bring the fun back to planning by helping friends, families,
              and teams decide faster, play smarter, and make memories that last.
            </p>
          </div>

          <div className="block-story">
            <h2>🎉 What We’re Building</h2>
            <p>
              PartyDecider turns decisions into moments. Whether it’s “Who’s paying?”, running a quick Raffle,
              or using our upcoming Moments Planner to organize group events, we make planning together effortless
              and enjoyable.
            </p>
            <p>
              Our goal is simple: make every get-together, from casual nights to milestone celebrations,
              easier to start and harder to forget.
            </p>
          </div>

          <div className="block-story">
            <h2>🚀 Our Journey</h2>
            <div className="journey-cards">
              <div className="journey-card journey-card--left appear-up">
                <div className="journey-card__emoji" aria-hidden="true">💡</div>
                <div className="journey-card__content">
                  <h3>2021 – 2023</h3>
                  <p>We began exploring simple ways to help people collaborate and connect digitally.</p>
                </div>
              </div>
              <div className="journey-card journey-card--left appear-up">
                <div className="journey-card__emoji" aria-hidden="true">🎲</div>
                <div className="journey-card__content">
                  <h3>2025</h3>
                  <p>PartyDecider takes shape as our newest project under the FLW Connect Technologies umbrella, designed by a small team that listens, learns, and builds with its users.</p>
                </div>
              </div>
              <div className="journey-card journey-card--left appear-up">
                <div className="journey-card__emoji" aria-hidden="true">🚀</div>
                <div className="journey-card__content">
                  <h3>December 2025</h3>
                  <p>Beta launch of PartyDecider 🎊</p>
                </div>
              </div>
              <div className="journey-card journey-card--left appear-up">
                <div className="journey-card__emoji" aria-hidden="true">🎯</div>
                <div className="journey-card__content">
                  <h3>Next Milestone</h3>
                  <p>Reaching our first 100 users and growing a community that loves making moments happen.</p>
                </div>
              </div>
              </div>
          </div>

          <div className="block-story">
            <h2>🤝 How We Work</h2>
            <p>
              We believe the best ideas come from listening. PartyDecider was built through collaboration and
              open partnerships, turning everyday feedback into real features. We’re always ready to hear from you,
              refine what we make, and grow together.
            </p>
          </div>

          <div className="block-story">
            <h2>🍁 Proudly Built in Canada</h2>
            <p>
              Born in Canada and built for everyone, PartyDecider reflects the open, friendly spirit that inspires us
              global in reach, local in heart.
            </p>
          </div>

          <div className="block-story">
            <h2>🔒 Built on Trusted Technology</h2>
            <p>
              Behind the scenes, PartyDecider runs on Google Cloud Infrastructure with encrypted Firestore data storage,
              secure HTTPS by default, and sign-in powered by Firebase Authentication.
            </p>
            <p>
              All data is encrypted in transit and at rest, and we align our practices with SOC 2 and ISO 27001 controls
              built into Google&apos;s cloud ecosystem.
            </p>
            <p>
              We use Google Analytics 4 with privacy-enhanced measurement and consent mode, and we follow British Columbia&apos;s
              PIPA and Canada&apos;s CASL requirements so planning feels transparent, safe, and trustworthy.
            </p>
          </div>

          <div className="block-story">
            <h2>🌟 Join the Fun</h2>
            <p>Plan faster. Laugh more. Create moments that matter.</p>
            <p>Because when getting together feels easy, life gets a little better.</p>
          </div>
        </section>
      </main>
    </>
  );
}
